(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-popup"]) return;
  try {
    
class SearchPopup extends HTMLElement {
    #abortController = null;
    connectedCallback() {
        this.#init();
        // const sectionId = this.dataset.sectionId;
        // const button = this.querySelector('.my-btn');

        // button.addEventListener('click', () => {
        // console.log(`Button clicked inside section: ${sectionId}`);
        // });
    }
    #init(){
        this.updateSeachContent();
    }
    async updateSeachContent(){
        const html =await this.fetchSearch();
        this.querySelector('.search-container').innerHTML = html.innerHTML;
    }
    fetchSearch(terms = null){
        if (this.#abortController) {
            const parser = document.createElement('div');
            parser.innerHTML = response;
            const ajaxContainer = parser.querySelector('[data-ajax-container="products"]');
            abortController.abort();
        }

        this.#abortController = new AbortController();
        const signal = this.#abortController.signal;
        const url = Theme.routes.search_url + '?type=product&view=ajax' + (terms == null ? '' : 'q='+ terms );

        // $('.header__search-form-results').addClass('ajax-loading');
        return fetch(url, {signal}).
        then((response) => {
            if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.text();
        }).
        then((response) => {
            const parser = document.createElement('div');
            parser.innerHTML = response;
            const ajaxContainer = parser.querySelector('[data-ajax-container="search"]');
            return ajaxContainer;
        });
    }
}

customElements.define('search-popup', SearchPopup);

  } catch(e) { console.error(e); }
})();
})();
